<template>
  <base-container ref="container" style="height: 100%">
    <ArtisanGrid
    ref="resouce"
    metaKey="JyResourceInfo"
    :rowBtnPermission="rowBtnPermission"
    isTree
    defaultExpandAll
    @roomAddWindow="roomAddWindow"
    :confirmBefore="confirmBefore"
    :showDialogBefore="showDialogBefore"
    :metaInited="metaInited"
    :leftOption="leftOption"
    dialogWidth="80%"
    dialogHeight="80%"
    >
      <template #leftAside>
        <el-tree
        :data="treeData"
        node-key="id"
        default-expand-all
        ref="tree"
        highlight-current
        :props="{ label: 'name' }"
        :expand-on-click-node="false"
        @current-change="treeChange"
        >
        </el-tree>
      </template>
      <template #dialogRight>
        <artisan-group style="width: 50%; height: 100%" title="选择检验项目">
          <el-row style="margin-bottom: 10px">
            <el-col :span="12">
              <el-select size="mini" v-model="projectType" style="width: 100%">
                <el-option value="">所有</el-option>
                <el-option
                :value="item.value"
                :label="item.label"
                v-for="item in projectTypes"
                :key="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-input
              size="mini"
              v-model="val"
              placeholder="搜索关键字"
              ></el-input>
            </el-col>
          </el-row>
          <el-checkbox-group v-model="projectIds">
            <el-checkbox
            style="width: 50%; margin-right: 0"
            v-show="
                (project.type == projectType || !projectType) &&
                (project.deptId == deptId || !deptId) &&
                (project.name.indexOf(val) >= 0 || !val)
              "
            v-for="project in projects"
            :key="project.id"
            :label="project.id"
            >
              {{ project.name }}
            </el-checkbox>
          </el-checkbox-group>
        </artisan-group>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
  import { listByHos } from "@/api/jy/project";
  import { loadEnum } from "@/api/sys/dicType";
  import { getUserHosDepts } from "@/api/jy/dept";
  export default {
    data() {
      return {
        isLoading: false,
        projectType: "",
        projectTypes: [],
        projects: [],
        projectIds: [],
        val: "",
        data: "",
        hosId: "",
        depts: [],
        deptId: "",
        treeData: [],
        leftOption: {
          width: "15%",
        },
      };
    },
    created() {
      listByHos().then((res) => {
        this.projects = res.data.data;
      });
      loadEnum("JyProjectTypeOption").then((res) => {
        this.projectTypes = res.data.data;
      });
    },
    methods: {
      metaInited(option) {
        const col = option.columns.find((c) => c.code == "deptId");
        col.dicdata = [];
        getUserHosDepts().then((res) => {
          const data = res.data.data;
          data.forEach((c) => {
            let node = {
              id: c.id,
              name: c.name,
              type: "hos",
              children: c.jyDepts,
            };
            let depts = c.jyDepts.map((c) => {
              return {
                value: c.id,
                label: c.name,
              };
            });
            col.dicData = col.dicData.concat(depts);
            this.treeData.push(node);
          });
        });
      },
      treeChange(data, node) {
        if (data.type) {
          this.hosId = data.id;
          this.deptId = "";
        } else {
          this.hosId = node.parent.data.id;
          this.deptId = data.id;
        }
        this.$refs.resouce.reload({
          hosId: this.hosId,
          deptId: this.deptId,
        });
      },
      rowBtnPermission(row, btn) {
        if (btn.code == "roomAddWindow") {
          return row.parentId == "0";
        }
        return true;
      },
      showDialogBefore(dialog, data) {
        this.projectType = "";
        this.projectIds = data.projectIds;
        dialog.isShow = true;
      },
      confirmBefore(dialog, data) {
        data.projectIds = this.projectIds;
        return true;
      },
      roomAddWindow(row, btn) {
        btn.title = "添加窗口--" + row.name;
        let data = {
          type: "window",
          parentId: row.id,
          deptId: row.deptId,
          projectIds: [],
        };
        this.$refs.resouce.toAdd(btn, data);
      },
    },
  };
</script>

<style scoped></style>
